import { createContext, use } from 'react';
import type { Subscription } from '@packages/types';

export interface SubscriptionContextValue {
  subscription: Subscription | null | undefined;
  isLoading: boolean;
  needsSubscription: boolean;
  /** True for brand-new accounts that have never had a subscription - redirect to onboarding */
  needsOnboarding: boolean;
}

export const SubscriptionContext = createContext<SubscriptionContextValue | null>(null);

export function useSubscription(): SubscriptionContextValue {
  const ctx = use(SubscriptionContext);
  if (!ctx) throw new Error('useSubscription must be used within SubscriptionProvider');
  return ctx;
}
